import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
function formatDateUK(dateStr: string): string {
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric'
  });
}
const newsItems = [{
  image: 'https://images.unsplash.com/photo-1556761175-5973dc0f32e7?w=600&q=80',
  title: 'TM44 compliance: what you need to know before the fines',
  slug: '/knowledge-hub/tm44-compliance-what-you-need-to-know-before-the-fines',
  date: '2026-04-05',
  category: 'Guide'
}, {
  image: 'https://images.unsplash.com/photo-1573164713988-8665fc963095?w=600&q=80',
  title: 'Daikin vs generic warranties: why it matters for your business',
  slug: '/knowledge-hub/daikin-vs-generic-warranties-what-you-need-to-know',
  date: '2026-03-28',
  category: 'FAQ'
}, {
  image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=600&q=80',
  title: 'Ventilation requirements by sector: office, retail & hospitality',
  slug: '/knowledge-hub/ventilation-requirements-by-sector',
  date: '2026-03-15',
  category: 'Article'
}];
export function News() {
  return <section id="knowledge-hub" className="py-24 bg-[#D4DDE8]" data-id="element-365">
      <div className="container mx-auto px-6" data-id="element-366">
        <div className="flex justify-between items-end mb-12" data-id="element-367">
          <h2 className="text-4xl md:text-5xl font-serif" data-id="element-368">Resources</h2>
          <Link to="/knowledge-hub" className="hidden md:flex items-center gap-2 text-sm font-medium hover:text-accent transition-colors group" data-id="element-369">
            View all resources
            <img src="https://cdn.magicpatterns.com/uploads/okbpmyBbWVyrbcmsCAB9cm/arrow-right-navy.svg" alt="" className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-370" />
          </Link>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-371">
          {newsItems.map((item, index) => <motion.a href={item.slug} key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group block" data-id="element-372">
              <div className="relative aspect-[4/3] rounded-xl overflow-hidden mb-6" data-id="element-373">
                <img src={item.image} alt={`${item.title} — HVAC guide illustration`} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-374" />
              </div>
              <h3 className="text-lg font-medium mb-4 group-hover:text-accent transition-colors line-clamp-2" data-id="element-375">
                {item.title}
              </h3>
              <div className="flex items-center gap-3 text-xs text-primary-dark/50 uppercase tracking-wider" data-id="element-376">
                <span data-id="element-377">{formatDateUK(item.date)}</span>
                <span className="w-1 h-1 bg-primary-dark/20 rounded-full" data-id="element-378"></span>
                <span data-id="element-379">{item.category}</span>
              </div>
            </motion.a>)}
        </div>

        <div className="mt-8 md:hidden flex justify-center" data-id="element-380">
          <Link to="/knowledge-hub" className="flex items-center gap-2 text-sm font-medium hover:text-accent transition-colors group" data-id="element-381">
            View all resources
            <img src="https://cdn.magicpatterns.com/uploads/okbpmyBbWVyrbcmsCAB9cm/arrow-right-navy.svg" alt="" className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-382" />
          </Link>
        </div>
      </div>
    </section>;
}